import { setProcedureCondition } from "app/store/dashboard/surgery_types_procedures/slice/surgeryProcedureSlice";
import { resolveFilterValue } from "app/store/dashboard/surgery_types_procedures/utils/filterValues";
import useActiveProcedure from "components/pages/dashboard/surgery_types_procedures/hooks/useActiveProcedure";

const useSingleSelectFilter = (filter) => {
  const { procedureFilters, dispatch } = useActiveProcedure();
  const value = resolveFilterValue(filter, procedureFilters);

  const onChange = (nextValue) =>
    dispatch(setProcedureCondition({ field: filter.field, value: nextValue }));

  return { options: filter.options, value, onChange };
};

export default useSingleSelectFilter;
